import { MonoDatePickerWithDefaultPreset } from 'components/shared/DatePicker';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

type DateFieldProps = {
  value?: Nullable<string>;
  onChange?: (newValue: Nullable<string>) => void;
  isDisabled: boolean;
  isLoading: boolean;
  id: string;
  tabIndex?: number;
  isClearable?: boolean;
  displayPresets?: boolean;
  maxDate?: string;
  labelKey?: IntlKey;
};

export function DateField({
  value,
  onChange,
  isDisabled,
  isLoading,
  id,
  tabIndex,
  isClearable = false,
  displayPresets = false,
  maxDate = undefined,
  labelKey,
}: DateFieldProps) {
  return (
    <BlockOrientationFormGroup inputId={id} label={labelKey}>
      {isLoading ? (
        <DateFieldSkeleton />
      ) : (
        <MonoDatePickerWithDefaultPreset
          id={id}
          e2e={`${id}-date-picker`}
          disabled={isDisabled}
          allowWeekend={false}
          value={value ?? null}
          onChange={onChange}
          hidePresets={!displayPresets}
          isClearable={isClearable}
          tabIndex={tabIndex}
          maxDate={maxDate}
        />
      )}
    </BlockOrientationFormGroup>
  );
}

export const DateFieldSkeleton: FC = () => (
  <div className="input-group input-group-md">
    <span className="input-group-text text-primary">
      <em className="icon icon-sm text-secondary">today</em>
    </span>
    <div className="form-control form-control-md show">
      <Skeleton width="10em" />
    </div>
  </div>
);
